import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http'
import localeFrExtra from '@angular/common/locales/extra/fr'
import localeFr from '@angular/common/locales/fr'
import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideRouter, Router, withHashLocation} from '@angular/router'
import routes from './app-routes'
import {authInterceptor} from './application/auth.interceptor'
import {ENVIRONMENT, WINDOW} from './application/injection-tokens'
import {routeResolver} from './application/route-resolver'
import {ConfigService} from './services/config.service'
import {environment} from '../environments/environment'
import {responseInterceptor} from '@sparbanken-syd/sparbanken-syd-bankid'

registerLocaleData(localeFr, 'fr', localeFrExtra)


export const appConfig: ApplicationConfig = {
  providers: [
    {provide: WINDOW, useValue: globalThis},
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline',
        subscriptSizing: 'dynamic'
      }
    },
    {provide: ENVIRONMENT, useValue: environment},
    /**
     * Conditionally initializes `bootstrap` only for the `/admin` route,
     */
    provideAppInitializer(() => {
      return routeResolver(inject(ConfigService), inject(Router), inject(WINDOW))
    }),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, responseInterceptor])
    ),
    provideRouter(routes,
      withHashLocation())
  ]
}